var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTensorflow2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 2331.5 2500",
    viewBox: "0 0 2331.5 2500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1332.3 384.6v384.6l666.2 384.6v-384.6zm-1332.3 384.6v384.6l333.1 192.3v-384.6zm999.2 192.3-333.1 192.3v1153.8l333.1 192.4v-769.2l333.1 192.3v-384.6l-333.1-192.3z",
    fill: "#e55b2d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m1332.3 384.6-999.2 576.9v384.6l666.2-384.6v384.6l333.1-192.3v-769.2zm999.2 192.3-333.1 192.3v384.6l333.1-192.3zm-666.1 769.3-333.1 192.3v384.6l333.1-192.3zm-333.1 576.9-333.1-192.3v769.2l333.1-192.3z",
    fill: "#ed8e24"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m1332.3 0-1332.3 769.2 333.1 192.3 999.2-576.9 666.2 384.6 333.1-192.3zm0 1153.8-333.1 192.3 333.1 192.3 333.1-192.3z",
    fill: "#f8bf3c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTensorflow2);
export default __webpack_public_path__ + "static/media/tensorflow-2.84a4db00a79641b19fa7e3873b0f457b.svg";
export { ForwardRef as ReactComponent };